import React from 'react'
import gql from 'graphql-tag'
import {productIsDelivered} from 'lib/productHelpers'
import DeliveredFloorPlans from 'components/shared/DeliveredFloorPlans'
import ProductInputAssets from 'components/shared/ProductInputAssets'
import DefaultProductStatus from '../../DefaultProductStatus'

const FloorPlansProduct = ({match, product}) => {
  if (product.canProvideUserInput) {
    return (
      <ProductInputAssets
        product={product}
        description={
          <>
            <p>Last opp underlag for plantegning.</p>
            <p>Plantegning leveres innen 2 arbeidsdager.</p>
          </>
        }
      />
    )
  }

  if (productIsDelivered(product)) {
    return (
      <DeliveredFloorPlans
        product={product}
        estateId={match.params.estateId}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

FloorPlansProduct.fragment = gql`
  fragment FloorPlansProduct on FloorPlansProduct {
    quantity
    floors
    extraAssetUnitPrice
    remainingCredits
    assets {
      edges {
        approved
        node {
          id
          state
          ...on PlanDrawingCorrectionAsset { url }
          ...on PlanDrawingAsset {
            free
            assets {
              edges {
                node {
                  id
                  ...on PhotoAsset {
                    image(size: "monitor") {
                      url
                      thumbUrl
                      width
                      height
                      labels
                      filenameIndex
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    order {
      expressDelivery
    }
  }
`

export default FloorPlansProduct
